/** A positive amount, with an optional decimal comma or point and no grouping. */
export function parseFinanceAmount(raw: string): number | null {
  const value = raw.trim();
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(value)) return null;
  const amount = Number(value.replace(",", "."));
  return Number.isFinite(amount) && amount > 0 ? amount : null;
}

/** An opening balance may be zero or negative; grouping remains unsupported. */
export function parseFinanceBalance(raw: string): number | null {
  const value = raw.trim();
  if (!value) return 0;
  if (!/^-?\d+(?:[.,]\d{1,2})?$/.test(value)) return null;
  const amount = Number(value.replace(",", "."));
  return Number.isFinite(amount) ? amount : null;
}

/** Decimal text for reviewed writes: no grouping, exponent or binary rounding. */
export function parseFinanceDecimal(raw: string, options: { signed?: boolean; zero?: boolean; emptyZero?: boolean } = {}): string | null {
  const value = raw.trim();
  if (!value && options.emptyZero) return "0";
  if (!(options.signed ? /^-?\d{1,60}(?:[.,]\d{1,30})?$/ : /^\d{1,60}(?:[.,]\d{1,30})?$/).test(value)) return null;
  const text = value.replace(",", ".").replace(/^(-?)0+(?=\d)/, "$1").replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  const zero = !/[1-9]/.test(text);
  if (zero && !options.zero) return null;
  return zero ? "0" : text;
}

/** Calendar day on this device. UTC conversion would shift dates near midnight. */
export function localISODate(date = new Date()): string {
  if (!Number.isFinite(date.getTime())) return "";
  const year = String(date.getFullYear()).padStart(4, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Date-only records already carry the user's chosen day; never reinterpret it. */
export function dateInputFromTimestamp(timestamp: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(timestamp)) return timestamp;
  return localISODate(new Date(timestamp));
}
